// assets/related-products.js
class TFRelatedProducts {
  static selector = '[data-tf-related]';

  constructor(root) {
    this.root = root;
    this.slider = root.querySelector('.swiper-slider[data-url]');
    if (!this.slider) return;

    this.url = this.slider.dataset.url;
    this.mounted = false;

    this.mount();
  }

  // utils
  toInt(v, fallback = 0) {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  }
  toBool(v, fallback = false) {
    if (v === undefined || v === null) return fallback;
    return String(v).toLowerCase() === 'true';
  }

  getSwiperCtor() {
    return window.Swiper || (window.swiper && window.swiper.Swiper) || null;
  }

  buildSwiperConfig() {
    const el = this.slider;

    const preview = this.toInt(el.dataset.preview, 4);
    const tablet = this.toInt(el.dataset.tablet, 3);
    const mobileSm = this.toInt(el.dataset.mobileSm, 2);
    const mobile = this.toInt(el.dataset.mobile, 2);

    const spaceLg = this.toInt(el.dataset.spaceLg, 30);
    const spaceMd = this.toInt(el.dataset.spaceMd, 20);
    const space = this.toInt(el.dataset.space, 15);

    const hasPagination = this.toBool(el.dataset.pagination, true);
    const hasNavigation = this.toBool(el.dataset.navigation, true);

    const prevEl = this.root.querySelector('.nav-prev-swiper');
    const nextEl = this.root.querySelector('.nav-next-swiper');
    let paginationEl = this.root.querySelector('.tf-sw-pagination');

    if (hasPagination && !paginationEl) {
      paginationEl = document.createElement('div');
      paginationEl.className = 'pagination-bullet tf-sw-pagination d-xl-none';
      this.slider.insertAdjacentElement('afterend', paginationEl);
    }

    const config = {
      slidesPerView: preview,
      spaceBetween: spaceLg,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        0: { slidesPerView: mobile, spaceBetween: space },
        576: { slidesPerView: mobileSm, spaceBetween: space },
        768: { slidesPerView: tablet, spaceBetween: spaceMd },
        1200: { slidesPerView: preview, spaceBetween: spaceLg }
      }
    };

    if (hasNavigation && prevEl && nextEl) {
      config.navigation = { prevEl, nextEl };
    }

    if (hasPagination && paginationEl) {
      config.pagination = { el: paginationEl, clickable: true };
    }

    return config;
  }

  hasItems() {
    const wrapper = this.slider.querySelector('.swiper-wrapper');
    return !!(wrapper && wrapper.children && wrapper.children.length > 0);
  }

  normalizeSlides() {
    const wrapper = this.slider.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    [...wrapper.children].forEach((child) => {
      if (!child.classList.contains('swiper-slide')) child.classList.add('swiper-slide');
    });
  }

  async fetchAndHydrate() {
    if (this.hasItems()) return true;
    if (!this.url) return false;

    const res = await fetch(this.url, { credentials: 'same-origin' });
    if (!res.ok) return false;

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    // tìm đúng slider trong HTML trả về (section html)
    const fetchedSlider = doc.querySelector('.swiper-slider[data-url]');
    if (!fetchedSlider) return false;

    // replace inner HTML (swiper-wrapper...)
    this.slider.innerHTML = fetchedSlider.innerHTML;
    return true;
  }

  initSwiper() {
    const SwiperCtor = this.getSwiperCtor();
    if (!SwiperCtor) return;

    // destroy nếu có init cũ
    if (this.slider.swiper) {
      try {
        this.slider.swiper.destroy(true, true);
      } catch (_) {}
    }

    const config = this.buildSwiperConfig();
    try {
      new SwiperCtor(this.slider, config);
    } catch (e) {
      console.warn('[TFRelatedProducts] Swiper init failed:', e);
    }
  }

  async mount() {
    if (this.mounted) return;
    this.mounted = true;

    try {
      await this.fetchAndHydrate();
      
      if (window.InfiniteSlide) window.InfiniteSlide.mountAll(this.root);

      if (!this.hasItems()) {
        this.root.style.display = 'none';
        return;
      }

      this.normalizeSlides();
      this.initSwiper();
    } catch (e) {
      console.warn('[TFRelatedProducts] mount error:', e);
    }
  }

  static mountAll(scope = document) {
    scope.querySelectorAll(TFRelatedProducts.selector).forEach((root) => {
      // tránh mount trùng
      if (root.__tfRelatedMounted) return;
      root.__tfRelatedMounted = true;
      new TFRelatedProducts(root);
    });
  }
}

// auto mount
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => TFRelatedProducts.mountAll(), { once: true });
} else {
  TFRelatedProducts.mountAll();
}

// Shopify Theme Editor: section reload
document.addEventListener('shopify:section:load', (e) => {
  TFRelatedProducts.mountAll(e.target);
});
